import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {BadgesDetailsComponent} from './badges-details.component';

const routes: Routes = [
  {path: 'badges/details', component: BadgesDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class BadgesDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-details/badges-details-routing.module.ts